import { render, staticRenderFns } from "./groupDelModal.vue?vue&type=template&id=33346780&scoped=true"
import script from "./groupDelModal.vue?vue&type=script&setup=true&lang=js"
export * from "./groupDelModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./groupDelModal.vue?vue&type=style&index=0&id=33346780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33346780",
  null
  
)

export default component.exports